module.exports = __webpack_public_path__ + "img/t6.83732d6c.png";